'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redixDuty = undefined;

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _chainPattern = require('./chain-pattern');

var _chainPattern2 = _interopRequireDefault(_chainPattern);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var radixToRgb = function radixToRgb() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var res = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (color.indexOf('#') === -1) return 'next';
  color = color.slice(1);
  color = color.length <= 3 ? color.repeat(2) : color;
  res = color.replace(/(\w{2})/g, function (match, $1) {
    return parseInt($1, 16) + ',';
  });
  return 'rgba(' + res + '1)';
};
var rgbToRadix = function rgbToRadix() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var res = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (color.indexOf('rgb') === -1) return 'next';
  color = color.match(/\(([^\)]*)\)/)[1];
  color = color && color.split(',') || [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(color), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      if (res.length >= 6) return '#' + res;
      var radix = parseInt(key).toString(16);
      radix = radix.length === 1 ? '0' + radix : radix;
      res += radix;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return '#' + res;
};
/* eslint-disable no-new */
var redixDuty = new _chainPattern2.default(radixToRgb);
var rgbDuty = new _chainPattern2.default(rgbToRadix);

redixDuty.setNext(rgbDuty);

exports.redixDuty = redixDuty;